import React, { Component } from "react"
import { Helmet } from "react-helmet";
import Layout from "../components/layout";
import "../css/style.css";
import "../css/animate.min.css";
import "../css/responsive.css";
import "../css/bootstrap.min.css";
import downArrow from '../images/down-arrow.svg'
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, Thumbs, Mousewheel, Parallax } from 'swiper';
import ScrollAnimation from 'react-animate-on-scroll';
import { Animated } from "react-animated-css";
import PopupForm from "../components/popupForm";

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, Thumbs, Mousewheel, Parallax]);
var accItem;
class FaqSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: 90000000
    }
  }

  handlePopupWindow = () => {
    this.setState({ time: Math.random() })
  }

  componentDidMount() {

    accItem = document.getElementsByClassName('accordionItem');
    let accHD = document.getElementsByClassName('accordionItemHeading');
    for (let i = 0; i < accHD.length; i++) {
      accHD[i].addEventListener('click', this.toggleItem, false);
    }
  }
  accorfn = () => {

    accItem = document.getElementsByClassName('accordionItem');
    let accHD = document.getElementsByClassName('accordionItemHeading');
    for (let i = 0; i < accHD.length; i++) {
      accHD[i].addEventListener('click', this.toggleItem, false);
    }

  }
  toggleItem() {

    var itemClass = this.parentNode.className;
    for (let i = 0; i < accItem.length; i++) {
      accItem[i].className = 'accordionItem close';
    }
    if (itemClass == 'accordionItem close') {
      this.parentNode.className = 'accordionItem open';
    }
  }


  render() {


    return (

      <div>
        <PopupForm time={this.state.time} />
          
          <section class="faq-sec">

            <Animated animationIn="fadeInUp" animationOut="fadeInDown" isVisible={true}>

              <div class="container-fluid">
                <div class="row">
                  <div class="col-12">
                    <div id="american-dream-faq-inner" class="faq-inner wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s">


                      <div class="accordionWrapper">

                        <div id="american-dream-accordian" class="accordionItem open" onClick={() => this.accorfn()} >
                          <h2 class="accordionItemHeading" >What is The WorldGrad? <span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>The WorldGrad is an online education platform that has partnered with top tiered global institutions to bring online plus on-campus learning programs to India and regional markets. All our programs are configured such that you start your education online and complete the program on-campus at the overseas destination partner.
                            </p>
                          </div>
                        </div>
                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading">What is UniSmarter? <span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>UniSmarter is an online program offered by The WorldGrad in partnership with a group of overseas institutions in Australia and the United Kingdom. Students doing the UniSmarter program have the advantage of articulating to any of the overseas partner institutions upon successful completion, giving them  flexibility and optionality to choose their path.  </p>
                          </div>
                        </div>

                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading">What is the Global Online Accelerator Program? <span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>The Global Online Accelerator (GOA) Program has been developed in collaboration with UOW College, Australia which is a part of the University of Wollongong (global top 200). Students can do upto half of their first year of undergraduate studies in Business or Technology and articulate to UOW College and UOW for the rest of  the program. Students study in UOW College’s online environment and receive a transcript from the college upon completion.</p>
                          </div>
                        </div>

                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading" >Are The WorldGrad programs recognised?<span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>Yes. Our programs are fully recognised by our partner institutions for entry into their undergraduate and postgraduate degrees. You can learn more about our partner institutions by visiting <a href="/universities">partners</a>. All of our online programs are designed in collaboration with overseas partners and are taught by international faculty members </p>
                          </div>
                        </div>
                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading" >Will I get an admission offer from the overseas institution as well? <span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>Yes. If you have chosen an institution then we will arrange for a packaged offer from the overseas institution based on the applicable admissions requirement. In many cases, you will have the flexibility to choose your destination institution even later on. Please consult with our admissions counsellor for more information.
                            </p>
                          </div>
                        </div>
                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading">What will happen if my visa gets rejected?
                            <span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>Students who have passed The WorldGrad online programs are entitled to a full refund of their online program fee if their study visa application is rejected for any reason other than fraudulent or unverifiable documentation. Please speak to our admissions counsellors for more information. The terms of refund are also specified on the offer letter.
                            </p>
                          </div>
                        </div>
                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading">How do I apply for programs offered by The WorldGrad?<span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>You can fill in an information required after consulting with our admissions counsellor. The information required is similar to what you would need for securing an offer from an overseas institution and hence  serves a dual purpose. The application required verifiable information and supporting academic documents the details of which are mentioned on the application form and typically include -
                              <ul>
                                <li>  1.Passport copy</li>
                                <li> 2.Recent photograph</li>
                                <li>
                                  3.Certificate and mark sheet of your highest academic qualification
                                </li>
                                <li>  4.Proof of English proficiency
                                  *All document copies should be in English and need to be certified by  an authorised officer like a notary


                                </li>
                              </ul>


                            </p>
                          </div>
                        </div>
                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading">What are the fees and payment  details? <span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>Fees for all online programs are listed clearly on the program page.Indicative fees for the on-campus component are also provided but will depend on your actual term or year of enrolment with the overseas institution.  Other details such as program start date, payment date, bank information, etc. are detailed in the offer letters once admission is confirmed. The due dates for the fees will be mentioned in the offer letter.  Please note that you need to pay a minimum fee of INR 25000 to confirm your place in the online program within 7 days of receiving an offer.</p>
                          </div>
                        </div>
                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading">How many modules will I do with The WorldGrad and will that impact my post-study work rights?
                            <span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>Typically, you can do up to 4 modules online which is equivalent to half of the first year study load of an undergraduate program. Some of our partners may have slightly varying requirements so please check with our admissions counsellors as to the best suited online study path for you. Students who successfully complete the online program and their remaining undergraduate degree will be eligible for post-study work rights as per the country’s applicable regulations.</p>
                          </div>
                        </div>
                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading">Does online learning mean that I need to study everything by myself?<span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>Absolutely not! All programs offered by The WorldGrad are designed keeping in mind first-time online learners. We use the best content provided by our overseas partners for you to study. International teachers take weekly lectures and are  supported by Indian teachers for more personalised 1-1 support.</p>
                          </div>
                        </div>
                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading">How long is the online program and many hours a week do I have to study?<span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>Each study period is 7 weeks long and we recommend that you take 2 modules per study period. This way, your entire online component can be done within 15 weeks. You will be expected to study approximately 15 hours a week per module. This includes a combination of self learning, online classes and 1:1 tutoring. The WorldGrad offers you full flexibility to plan your study load and completion timelines based on your needs.
                              .</p>
                          </div>
                        </div>
                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading"> Will I get a tutor to help me with my online studies?<span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>The best part of The WorldGrad programs is that they are rich in academic support. We offer free, unlimited personalised one-to-one academic assistance to each student to ensure your specific learning needs are addressed. All students have access to an India-based online facilitator for each subject who is available  for one-to-one sessions to discuss academic concepts, solve questions or give guidance on assignments. Online facilitators are available 7 days a week over phone, text, chat or email. Additionally, you are also assigned a student success advisor in case of questions related to non-academic matters such as module planning, policy matters, progressing to overseas university or general well-being.
                              .</p>
                          </div>
                        </div>
                      </div>
                      <div class="enquire-btn">
                        <a class="btn btn-default" onClick={() => this.handlePopupWindow()}>Speak With Us</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </Animated>

          </section>



        {/* </Layout> */}




      </div>





    )


  }
}
export default FaqSection;
